import * as services from '@services/index';
import { ISubject, ITopicList, IVideos } from '@schemas/video';
import shuffle from 'lodash/shuffle';

interface State {
  videos: {
    [key: string]: ISubject & {
      pageNum: number;
      renderVideos: IVideos;
    };
  };
  topicList: {
    [key: string]: ITopicList;
  };
}

const COUNT_VIDEO = 6;

const initState: State = {
  videos: {},
  topicList: {}
};

const video = {
  state: initState,

  reducers: {
    updateState(state: State, payload: State) {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (dispatch) => ({
    async getSubjectListByChannel({ channelId, pageNum = 1 }, state) {
      const { videos } = state.video;
      try {
        const result: ISubject = await services.videos.getSubjectListByChannel({
          channelId,
          pageNum
        });
        const { photoVoList } = result;
        result.photoVoList = shuffle(photoVoList);
        if (!videos[channelId]) {
          const renderVideos = result.photoVoList.splice(0, COUNT_VIDEO);
          videos[channelId] = {
            ...result,
            renderVideos,
            pageNum
          };
        } else {
          const { photoVoList: vList } = videos[channelId];
          const newList = [...vList, ...result.photoVoList];
          const renderVideos = newList.splice(0, COUNT_VIDEO);
          videos[channelId] = {
            ...result,
            renderVideos,
            photoVoList: newList,
            pageNum
          };
        }
        this.updateState({
          videos: { ...videos }
        });
      } catch (error) {
        // this.updateState({
        //   videos
        // })
      }
    },

    async getMoreSubjectList(channelId, state) {
      const { videos } = state.video;
      const currentVideos = videos[channelId];
      const { photoVoList, pageNum } = currentVideos;
      if (photoVoList.length < COUNT_VIDEO * 2) {
        await this.getSubjectListByChannel({
          channelId,
          pageNum: pageNum + 1
        });
      } else {
        const renderVideos = photoVoList.splice(0, COUNT_VIDEO);
        currentVideos.renderVideos = renderVideos;
        this.updateState({
          videos: {
            ...videos
          }
        });
      }
    },

    async getTopicListByTag({ tag, pageNum = 1, pageSize = 3 }, state) {
      const { topicList, videos } = state.video;
      try {
        const result = await services.videos.getTopicListByTag({
          tag,
          pageNum,
          pageSize
        });
        const { list } = result;
        list.forEach((series, index) => {
          const channelId = series.albumId;
          if (!videos[channelId]) {
            const { photoVoList } = series;
            // eslint-disable-next-line no-param-reassign
            series.photoVoList = shuffle(photoVoList);
            const renderVideos = series.photoVoList.splice(0, COUNT_VIDEO);
            videos[channelId] = {
              ...series,
              renderVideos,
              pageNum: 1
            };
          }
        });

        if (!topicList[tag]) {
          topicList[tag] = result;
        } else {
          const { list: oldList } = topicList[tag];
          const { list: newList } = result;
          const mergeList = oldList.concat(newList);
          topicList[tag] = { ...topicList[tag], ...result, list: mergeList };
        }

        this.updateState({
          topicList: { ...topicList },
          videos: { ...videos }
        });
      } catch (error) {
        // return Promise.reject(error);
      }
    }
  })
};

export default video;
